import { listModelsForDomain, getCurrentModelLabel } from '@/libraries/api/faces'
import moment from 'moment'

export const TrainingToolModule = {
  namespaced: true,
  state: {
    filters: {
      date: new Date().valueOf(),
      faceHeight: undefined,
      cameraUUID: undefined,
      modelKey: undefined,
    },
    isEditing: false,
    availableModels: [],
    currentModel: {},
    filteringModel: undefined,
  },
  getters: {
    filters (state) {
      return state.filters
    },
    isEditing (state) {
      return state.isEditing
    },
    sortedModels (state) {
      let models = [...state.availableModels]
      models.sort((a, b) => {
        const aUnix = moment(a.label, 'MMM DD, YYYY HH:mm:ss').utc().valueOf()
        const bUnix = moment(b.label, 'MMM DD, YYYY HH:mm:ss').utc().valueOf()
        if (aUnix > bUnix) {
          return -1
        } else if (aUnix < bUnix) {
          return 1
        } else {
          return 0
        }
      })
      return models
    },
    currentModel (state) {
      return state.currentModel
    },
    filteringModel (state) {
      return state.filteringModel
    },
  },
  actions: {
    updateFilters: (context, filters) => {
      context.commit('updateFilters', filters)
    },
    updateEditing: (context, isEditing) => {
      context.commit('updateEditing', isEditing)
    },
    getModelsForCurrentDomain ({ commit, getters, rootState }) {
      const currentDomain = rootState.data.domains.current.uuid
      listModelsForDomain(currentDomain).then(response => {
        commit('setAvailableModels', response.data.results)
      }).catch(error => {
        console.error('Model.vue: ', error)
      })
    },
    getCurrentModel ({ rootState, commit }) {
      const currentDomain = rootState.data.domains.current.uuid
      getCurrentModelLabel(currentDomain).then(response => {
        commit('setCurrentModel', response.data)
      }).catch(error => {
        console.error('Model.vue: ', error)
        this.currentModel = false
      })
    },
  },
  mutations: {
    updateFilters (state, filters) {
      if (filters.modelKey) {
        const incoming = filters.modelKey.substring(0, 21)
        const index = state.availableModels.findIndex(model => model.label === incoming)
        filters.modelKey = state.availableModels[index].key
        state.filteringModel = state.availableModels[index]
      }
      state.filters = Object.assign(state.filters, filters)
    },
    setFilteringModel (state, filteringModel) {
      state.filteringModel = filteringModel
    },
    updateEditing (state, isEditing) {
      state.isEditing = isEditing
    },
    setAvailableModels (state, models) {
      const mapped = models.map(result => {
        const label = moment.utc(result.label, 'YYYY-MM-DD-HH-mm-ss').local().format('MMM DD, YYYY HH:mm:ss')
        const top1 = Math.round((parseFloat(result.top1_accuracy) * 100) * 100) / 100
        const top5 = Math.round((parseFloat(result.top5_accuracy) * 100) * 100) / 100
        const key = result.label
        return {
          label,
          top1,
          top5,
          key,
        }
      })
      state.availableModels = mapped
    },
    setCurrentModel (state, currentModel) {
      state.currentModel = {
        label: moment.utc(currentModel, 'YYYY-MM-DD-HH-mm-ss').local().format('MMM DD, YYYY HH:mm:ss'),
        key: currentModel,
      }
    },
  },
}
